module.exports = [{"type":"hash","text":"Connection limitations"},{"type":"normal","text":"A websocket is limited to a maximum of 200 topics, and 80403 error codes will be returned."},{"type":"normal","text":"An IP limit is up to 60 websockets, beyond which the link will fail."}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/introduce/00_limit.json
// module id = /ur1
// module chunks = 3